module.exports = __webpack_public_path__ + "img/clipboard.91e0272e.svg";